module.exports = __webpack_public_path__ + "static/media/sad.fe65b67e.png";